import React from 'react';

const Footer = () => (
  <div className="mt-24 bg-white dark:bg-secondary-dark-bg">
    <p className="dark:text-gray-200 text-gray-700 text-center p-10">
      © 2023 All rights reserved by <a className='text-blue-600' target='_blank' href="https://www.linkedin.com/in/mahmoud-hawash-757222202/">
        Mahmoud Hawash
      </a>
    </p>
  </div>
);

export default Footer;